<script>
export default {
  name: 'UlCardTitle',
  props: {
    border: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'ul-card-title--border': this.border,
      };
    },
  },
};
</script>
<template>
  <div class="ul-card-title" :class="classes">
    <div class="ul-card-title__name">
      <slot></slot>
    </div>
    <div class="ul-card-title__btn">
      <slot name="btn"></slot>
    </div>
  </div>
</template>
<style lang="scss">
  .ul-card-title {
    position: relative;
    display: flex;
    padding: 0 0 24px 0;
    justify-content: space-between;

    &__name {
      font-size: 18px;
      text-transform: uppercase;
      font-weight: 500;
      height: 24px;
    }

    &__btn {
      height: 36px;
      margin: -6px;
      display: flex;
      align-items: center;
    }

    &--border {
      margin-bottom: 24px;

      &:after {
        content: '';
        position: absolute;
        left: -24px;
        bottom: 0;
        width: calc(100% + 48px);
        height: 1px;
        background: #999999;
      }
    }
  }
</style>
